export interface IThailandProvince {
  id: number;
  name_th: string;
  name_en: string | null;
  code: number;
  group: ThailandRegionEnum;
  createdAt: Date;
  updatedAt: Date;
}

export enum ThailandRegionEnum {
  BANGKOK_METROPOLIS = 'BANGKOK_METROPOLIS',
  NORTHERN = 'NORTHERN',
  NORTHEASTERN = 'NORTHEASTERN',
  CENTRAL = 'CENTRAL',
  SOUTHERN = 'SOUTHERN',
  WESTERN = 'WESTERN',
  EASTERN = 'EASTERN',
}
